var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"host-ad"},[[_c('Table',{attrs:{"border":false,"columns":_vm.columns1,"data":_vm.list,"disabled-hover":false,"no-data-text":"暂无数据"},scopedSlots:_vm._u([{key:"name",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_vm._v(_vm._s(row.name))]}},{key:"nameUrl",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_vm._v(_vm._s(row.nameUrl))]}},{key:"nameEn",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_vm._v(_vm._s(row.nameEn))]}},{key:"nameEnUrl",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_vm._v(_vm._s(row.nameEnUrl))]}},{key:"remark",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_vm._v(_vm._s(row.remark))]}},{key:"remarkEn",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_vm._v(_vm._s(row.remarkEn))]}},{key:"linkText",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_vm._v(_vm._s(row.linkText))]}},{key:"linkUrl",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_vm._v(_vm._s(row.linkUrl))]}},{key:"linkTextEn",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_vm._v(_vm._s(row.linkTextEn))]}},{key:"linkUrlEn",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_vm._v(_vm._s(row.linkUrlEn))]}},{key:"imgSet",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_c('div',{staticStyle:{"display":"flex","align-items":"center","padding":"10px 0","flex-wrap":"wrap"}},_vm._l((row.imgSet),function(item,index){return _c('img',{key:index,staticStyle:{"width":"60px","height":"60px","margin-bottom":"5px"},attrs:{"src":item.ImgUrl},on:{"click":function($event){_vm.visible=true;_vm.imgurl=item.ImgUrl;}}})}),0)]}},{key:"imgSetEn",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_c('div',{staticStyle:{"display":"flex","align-items":"center","padding":"10px 0","flex-wrap":"wrap"}},_vm._l((row.imgSetEn),function(item,index){return _c('img',{key:index,staticStyle:{"width":"60px","height":"60px","margin-bottom":"5px"},attrs:{"src":item.ImgUrl},on:{"click":function($event){_vm.visible=true;_vm.imgurl=item.ImgUrl;}}})}),0)]}},{key:"showIndex",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_vm._v(_vm._s(row.showIndex))]}},{key:"action",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_c('p',{staticStyle:{"color":"#1890ff","cursor":"pointer"},on:{"click":function($event){return _vm.setShow(row)}}},[_vm._v("编辑")]),_c('Poptip',{attrs:{"confirm":"","title":"确认是否删除?","transfer":true},on:{"on-ok":function($event){return _vm.delItem(row)}}},[_c('p',{staticStyle:{"color":"#f00","cursor":"pointer"}},[_vm._v("删除")])])]}}])})],_c('iModal',{attrs:{"title":"查看图片","class-name":"vertical-center-modal","width":"600px","footer-hide":""},model:{value:(_vm.visible),callback:function ($$v) {_vm.visible=$$v},expression:"visible"}},[_c('div',{staticStyle:{"width":"100%","height":"100%"}},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":_vm.imgurl}})])]),_c('div',[_c('webMarathonEdit',{attrs:{"show":_vm.editShow,"editInfo":_vm.editInfo},on:{"finish":function($event){return _vm.init()},"close":function($event){_vm.editShow=false;_vm.editInfo=null;}}})],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }